import { useState, useEffect, createElement } from 'react';
import { useNavigate } from 'react-router';
import axios from 'axios';
import { fetchToken } from './Auth';

// const useApi = () => {
//   const navigate = useNavigate();

//   const instance = axios.create();
//   instance.interceptors.request.use(
//     (response) => response,
//     (error) => {
//       switch (error.response?.status) {
//         case 401:
//           localStorage.removeItem('temitope');
//           navigate('/login'); // navigateを使用してリダイレクト
//           return Promise.reject(error.response?.data);
//       }
//       return Promise.reject(error);
//     },
//   );

//   return instance;
// };

export const useGetApi = (url) => {
  const getApi = () => {
    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + fetchToken(),
    };

    const res = axios
      .get(url, { headers: headers })
      .then((response) => response)
      .catch((error) => Promise.reject(error));

    return res;
  };

  return getApi;
};

export const getClient = (clientId) => {
  const headers = {
    accept: 'application/json',
    Authorization: 'Bearer ' + fetchToken(),
  };

  const response = axios
    .get('/api/v1/clients/' + clientId + '/', { headers: headers })
    .then((response) => {
      // setData(response.data);
      // navigate(/"");
      return response;
    })
    .catch((error) => {
      // if (error.response.status === 401) {
      //   localStorage.removeItem('temitope');
      //   navigate('/login');
      // throw new Error(`No response! ${error.message}`);
      // }

      return Promise.reject(error);
    });

  return response;
};

export const getUnits = (clientId, skip, limit) => {
  const headers = {
    accept: 'application/json',
    Authorization: 'Bearer ' + fetchToken(),
  };
  const response = Promise.all([
    axios.get('/api/v1/clients/' + clientId + '/units/', {
      params: { skip, limit },
      headers: headers,
    }),
    axios.get('/api/v1/clients/' + clientId + '/units/count/', {
      headers: headers,
    }),
    axios.get('/api/v1/clients/' + clientId + '/files/', {
      params: { skip, limit },
      headers: headers,
    }),
  ])
    .then(([resUnits, resCount, resFiles]) => {
      return { ...resUnits, count: resCount.data, files: resFiles.data };
    })
    .catch((error) => {
      // if (error.response.status === 401) {
      //   localStorage.removeItem('temitope');
      //   navigate('/login');
      // }

      return Promise.reject(error);
    });

  return response;
};

export const getSelfClient = () => {
  const headers = {
    accept: 'application/json',
    Authorization: 'Bearer ' + fetchToken(),
  };
  const response = axios
    .get('/api/v1/self/client/', { headers: headers })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      // return Promise.reject(error);

      if (error.response.status === 401) {
        localStorage.removeItem('temitope');
        // navigate('/login');
      }
    });

  return response;
};

export const ClientName = ({ clientId, as, children, ...props }) => {
  const [clientName, setClientName] = useState();
  const getClient = useGetApi('/api/v1/clients/' + clientId + '/');

  useEffect(() => {
    if (clientId) {
      getClient().then((response) => {
        setClientName(response.data.name);
      });
    }

    // if (as) {
    //   as.props.defaultValue = clientName;
    // }
  }, [clientId]);

  return (
    <>
      {as ? (
        <>{createElement(as, { ...props, defaultValue: clientName }, children)}</>
      ) : (
        <>{clientName}</>
      )}
    </>
  );
};
